import type { TestResourceApi } from "../../api/TestResourceApi";
import type { CreateTestChildResource } from "../../generated/dto/CreateTestChildResource";
import type { CreateTestResource } from "../../generated/dto/CreateTestResource";
import type { DeleteTestChildResource } from "../../generated/dto/DeleteTestChildResource";
import type { DeleteTestResource } from "../../generated/dto/DeleteTestResource";
import type { TestChildResource } from "../../generated/dto/TestChildResource";
import type { TestChildResourceFetchOptions } from "../../generated/dto/TestChildResourceFetchOptions";
import type { TestResource } from "../../generated/dto/TestResource";
import type { TestResourceDescribeChildRequest } from "../../generated/dto/TestResourceDescribeChildRequest";
import type { TestResourceFetchOptions } from "../../generated/dto/TestResourceFetchOptions";
import type { TestResourceFormatChildLabelsRequest } from "../../generated/dto/TestResourceFormatChildLabelsRequest";
import type { TestResourceFormatTextWithFlagRequest } from "../../generated/dto/TestResourceFormatTextWithFlagRequest";
import type { TestResourceLoadBoundResourceChildrenRequest } from "../../generated/dto/TestResourceLoadBoundResourceChildrenRequest";
import type { TestResourceRef } from "../../generated/dto/TestResourceRef";
import type { TestResourceReturnBoundResourceEnvelopeRequest } from "../../generated/dto/TestResourceReturnBoundResourceEnvelopeRequest";
import type { TestResourceReturnSampleTimestampRequest } from "../../generated/dto/TestResourceReturnSampleTimestampRequest";
import type { TestResourceSummary } from "../../generated/dto/TestResourceSummary";
import type { TestResourceTransportEnvelope } from "../../generated/dto/TestResourceTransportEnvelope";
import type { UpdateTestChildResource } from "../../generated/dto/UpdateTestChildResource";
import type { UpdateTestResource } from "../../generated/dto/UpdateTestResource";

export class TestResourceFrontendService {
  constructor(private readonly api: TestResourceApi) {}
  async getTestResource(id: number, options?: TestResourceFetchOptions): Promise<TestResource> {
    return this.api.getTestResource(id, options)
  }
  async getTestChildResource(id: number, options?: TestChildResourceFetchOptions): Promise<TestChildResource> {
    return this.api.getTestChildResource(id, options)
  }
  async createTestResource(source: CreateTestResource): Promise<TestResource> {
    return this.api.createTestResource(source)
  }
  async createTestChildResource(source: CreateTestChildResource): Promise<TestChildResource> {
    return this.api.createTestChildResource(source)
  }
  async updateTestResource(source: UpdateTestResource): Promise<TestResource> {
    return this.api.updateTestResource(source)
  }
  async updateTestChildResource(source: UpdateTestChildResource): Promise<TestChildResource> {
    return this.api.updateTestChildResource(source)
  }
  async deleteTestResource(source: DeleteTestResource): Promise<void> {
    return this.api.deleteTestResource(source)
  }
  async deleteTestChildResource(source: DeleteTestChildResource): Promise<void> {
    return this.api.deleteTestChildResource(source)
  }
  async getTestResourceTestChildren(id: number, options?: TestChildResourceFetchOptions): Promise<Array<TestChildResource>> {
    return this.api.getTestResourceTestChildren(id, options)
  }
  async getTestChildResourceTestResource(id: number, options?: TestResourceFetchOptions): Promise<TestResource> {
    return this.api.getTestChildResourceTestResource(id, options)
  }
  async acceptTextValueStaff(value: string): Promise<void> {
    return this.api.acceptTextValueStaff(value)
  }
  async computedValueTestStaff(ref: TestResourceRef): Promise<string> {
    return this.api.computedValueTestStaff(ref)
  }
  async describeChildStaff(request: TestResourceDescribeChildRequest): Promise<string> {
    return this.api.describeChildStaff(request)
  }
  async formatChildLabelsStaff(request: TestResourceFormatChildLabelsRequest): Promise<string> {
    return this.api.formatChildLabelsStaff(request)
  }
  async formatTextWithFlagStaff(request: TestResourceFormatTextWithFlagRequest): Promise<string> {
    return this.api.formatTextWithFlagStaff(request)
  }
  async getTestResourceSummaryStaff(): Promise<TestResourceSummary> {
    return this.api.getTestResourceSummaryStaff()
  }
  async loadBoundResourceChildrenStaff(request: TestResourceLoadBoundResourceChildrenRequest): Promise<TestResourceTransportEnvelope> {
    return this.api.loadBoundResourceChildrenStaff(request)
  }
  async loadChildrenFromReferenceStaff(ref: TestResourceRef): Promise<void> {
    return this.api.loadChildrenFromReferenceStaff(ref)
  }
  async loadTestResourceChildrenStaff(): Promise<void> {
    return this.api.loadTestResourceChildrenStaff()
  }
  async returnBoundResourceEnvelopeStaff(request: TestResourceReturnBoundResourceEnvelopeRequest): Promise<TestResourceTransportEnvelope> {
    return this.api.returnBoundResourceEnvelopeStaff(request)
  }
  async returnSampleTimestampStaff(request: TestResourceReturnSampleTimestampRequest): Promise<Date> {
    return this.api.returnSampleTimestampStaff(request)
  }
  async verifyBoundResourceStaff(dto: TestResourceRef): Promise<void> {
    return this.api.verifyBoundResourceStaff(dto)
  }
}
